import React from "react";

export default function Select<T extends string | number>({
  className,
  options,
  value,
  onChange,
  ariaLabel
}: {
  className?: string;
  options: Record<T, string> | { label: string; value: string | number }[];
  value: T | null | undefined;
  onChange(value: T): void;
  ariaLabel?: string;
}) {
  function renderOptions() {
    const isArray = Array.isArray(options);
    if (!isArray) {
      const optionList = Object.keys(options) as T[];

      return (
        <>
          {optionList.map((c, i) => (
            <option key={i} value={c}>
              {(options as Record<T, string>)[c]}
            </option>
          ))}
        </>
      );
    } else {
      return (
        <>
          {(options as { label: string; value: string | number }[]).map(
            (c, i) => (
              <option key={i} value={c.value}>
                {c.label}
              </option>
            )
          )}
        </>
      );
    }
  }

  // Don't render the built-in blank when the caller already provides a labeled
  // placeholder as the first array option (value=0, label starting with "—" or "--").
  const hasCallerPlaceholder =
    Array.isArray(options) &&
    (options as { label: string; value: string | number }[]).length > 0 &&
    (options as { label: string; value: string | number }[])[0].value === 0 &&
    /^[—\-]{1,2}/.test((options as { label: string; value: string | number }[])[0].label);

  return (
    <select
      className={`w-full border rounded-md p-2 cursor-pointer h-10 ${
        className || ""
      }`}
      aria-label={ariaLabel}
      value={value === null || value === undefined ? "" : value}
      onChange={(e) => onChange(e.currentTarget.value as T)}
    >
      {!hasCallerPlaceholder && <option value={""}>-- Select --</option>}
      {renderOptions()}
    </select>
  );
}
